(() => {
  document.querySelectorAll('[data-ah-gear-guide]').forEach((root) => {
    const options = root.querySelectorAll('[data-gear-title]');
    const result = root.querySelector('.ah__gear-result');
    const title = root.querySelector('[data-gear-result-title]');
    const copy = root.querySelector('[data-gear-result-copy]');
    const price = root.querySelector('[data-gear-result-price]');
    const image = root.querySelector('[data-gear-result-image]');
    const cta = root.querySelector('[data-gear-result-cta]');
    if (!options.length || !result || !title || !copy || !cta || !price || !image) return;
    options.forEach((option) => {
      option.addEventListener('click', () => {
        options.forEach((item) => {
          const active = item === option;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        result.classList.add('is-changing');
        window.setTimeout(() => {
          title.textContent = option.dataset.gearTitle || '';
          copy.textContent = option.dataset.gearCopy || '';
          price.textContent = option.dataset.gearPrice || '';
          image.src = option.dataset.gearImage || '';
          image.alt = option.dataset.gearImageAlt || '';
          cta.textContent = option.dataset.gearCta || 'Shop';
          cta.href = option.dataset.gearHref || '/collections/all';
          result.classList.remove('is-changing');
        }, 120);
      });
    });
  });
})();